import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// CORE BACKGROUND JOB SCHEDULE SCHEMA
/////////////////////////////////////////

export const CoreBackgroundJobScheduleSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().nullable(),
  name: z.string(),
  jobType: z.string(),
  jobParameters: NullableJsonValue.optional(),
  cronSchedule: z.string(),
  enabled: z.boolean(),
  lastJobEnqueuedAt: z.coerce.date().nullable(),
  enqueueNextJobAfter: z.coerce.date().nullable(),
  backgroundJobId: z.number().int().nullable(),
  coreIntegrationEsriSettingId: z.number().int().nullable(),
})

export type CoreBackgroundJobSchedule = z.infer<typeof CoreBackgroundJobScheduleSchema>

export default CoreBackgroundJobScheduleSchema;
